import React, {memo} from 'react'
import {Dropdown, Label, Menu} from 'semantic-ui-react'
import {
  withChildPathProps,
  withPropsPresent,
  withServiceData,
  withVersionData,
  withConflictsData,
  withNavigation
} from '../../../hoc'
import {getPublishedOrFirstVersion} from '../../../util'
import {PendingTasks} from '../../shared'

const getPathPrefix = (serviceId) => {
  const basePath = '/c/services/:serviceId/versions'
  return basePath.replace(':serviceId', serviceId)
}

const _Versions = (props) => {
  const {
    tab,
    service,
    version,
    conflicts,
    children,
    navigate
  } = props

  const onNav = (e, data) => {
    navigate(`${getPathPrefix(service.id)}/${version.id}/${data.name}`)
  }

  const onManageVersions = (e) => {
    e.preventDefault()
    navigate(`${getPathPrefix(service.id)}/manage`)
  }

  const onVersionSelected = (version) => {
    navigate(`${getPathPrefix(service.id)}/${version.id}/${tab}`)
  }

  return (
    <div data-testid='version-container'>
      {
        tab !== 'manage' && (
          <Menu pointing data-testid='version-container-menu'>
            <Menu.Item name='environments' active={tab === 'environments'}
                       data-testid='versions-container-environments-tab'
                       onClick={onNav}>Mock</Menu.Item>
            <Menu.Item name='contract' active={tab === 'contract'}
                       data-testid='versions-container-contract-tab'
                       onClick={onNav}>Contract</Menu.Item>
            <Menu.Item name='docs' active={tab === 'docs'}
                       data-testid='versions-container-docs-tab'
                       onClick={onNav}>Docs</Menu.Item>
            {
              conflicts.length > 0 && (
                <Menu.Item name='conflicts' active={tab === 'conflicts'}
                           data-testid='versions-container-conflicts-tab'
                           onClick={onNav}>
                  Conflicts
                  <Label pointing='left' content={conflicts.length} color='olive'/>
                </Menu.Item>
              )
            }
            <Menu.Menu position='right'>
              <Menu.Item>
                <Dropdown pointing={false} fluid
                          data-testid='versions-menu'
                          trigger={<span><Label>Version: {version ? version.name : '...loading'}</Label></span>}>
                  <Dropdown.Menu>
                    {
                      service.versions.map(v => (
                        <Dropdown.Item key={v.id}
                                       active={version ? (version.id === v.id) : false}
                                       text={v.name}
                                       data-test='versions-menu-item'
                                       label={{
                                         color: v.published ? 'green' : 'grey',
                                         empty: true,
                                         circular: true
                                       }}
                                       onClick={() => onVersionSelected(v)}/>
                      ))
                    }
                    <>
                      <Dropdown.Divider/>
                      <Dropdown.Item icon='folder open outline' text='Manage Versions'
                                     data-testid='versions-menu-manage-item'
                                     onClick={onManageVersions}/>
                    </>
                  </Dropdown.Menu>
                </Dropdown>

              </Menu.Item>
            </Menu.Menu>
          </Menu>
        )
      }
      {
        tab !== 'manage' && (
          <PendingTasks parentIds={[service.id, version.id]} triggers={[tab]}>
            {children}
          </PendingTasks>
        )
      }
      {
        tab === 'manage' && children
      }
    </div>
  )
}

let Versions = (props) => {
  const path = props.location.pathname
  let {service, serviceId, version, versionId, conflicts} = props

  if ((service || {}).id !== serviceId || (version || {}).id !== versionId) {
    return null
  }
  if (path.endsWith('/conflicts') && conflicts.length === 0) {
    props.navigate(`${version.id}/environments`, {forwardQueryParams: ['returnPath']})
    return null
  }
  if (!versionId) {
    version = getPublishedOrFirstVersion(service)
  }
  if (path.endsWith('/versions')) {
    if (!!version) {
      props.navigate(`${version.id}/environments`, {forwardQueryParams: ['returnPath']})
    } else {
      props.navigate(`manage`)
    }
    return null
  }

  let tab = 'unknown'
  if (path.indexOf('environments') > -1) {
    tab = 'environments'
  }
  if (path.indexOf('contract') > -1) {
    tab = 'contract'
  }
  if (path.indexOf('docs') > -1) {
    tab = 'docs'
  }
  if (path.indexOf('conflicts') > -1) {
    tab = 'conflicts'
  }
  if (path.indexOf('manage') > -1) {
    tab = 'manage'
  }

  props = {...props, version, tab}

  return (
    <_Versions {...props}/>
  )
}

Versions = withPropsPresent(Versions, ['service', 'versionLoaded', 'conflicts'])
Versions = withVersionData(Versions, 'Loading version...')
Versions = withServiceData(Versions, 'Loading service...')
Versions = withConflictsData(Versions, 'Loading conflicts...')
Versions = withNavigation(Versions)
Versions = withChildPathProps(Versions)
Versions = memo(Versions)


export {_Versions, Versions}

export default Versions